import React from 'react'
import { Container, Row, Col } from 'react-bootstrap'
import Skeleton from 'react-loading-skeleton'

const ExpressCheckoutSkeleton = () => (
  <Container>
    <Row>
      <Col xs={12} className="d-flex justify-content-center my-2">
        <Skeleton rectangle={true} height={10} width={250} />
      </Col>
      <Col xs={6} className="my-2 px-3">
        <Skeleton
          rectangle={true}
          height={50}
          className="paymentButtonSkeleton"
        />
      </Col>
      <Col xs={6} className="my-2 px-3">
        <Skeleton
          rectangle={true}
          height={50}
          className="paymentButtonSkeleton"
        />
      </Col>
    </Row>
  </Container>
)

export default ExpressCheckoutSkeleton
